import {
  createReusableStylesheet,
  iconFontReusableStylesheet,
  tcwebReusableStylesheet,
  type ReusableStylesheet,
} from '@trimble/stylesheets';
import issueSharingModalStyles from './components/IssueSharingModal/IssueSharingModal.css?inline';
import issueExchangeWidgetStyles from './modules/IssueExchangeWidget/IssueExchangeWidget.css?inline';
import issueExportStyles from './modules/IssueExport/IssueExport.css?inline';
import issueRightPanelStyles from './modules/IssueRightPanel/IssueRightPanel.css?inline';
import baseStyles from '../styles.css?inline';
import tailwindStyles from '../tailwind.css?inline';
import topicsStyles from '../styles/topics.css?inline';

export const tcIssueManagementBaseStylesheet = createReusableStylesheet(
  'tc-issue-management:base-styles',
  baseStyles
);
export const tcIssueManagementTailwindStylesheet = createReusableStylesheet(
  'tc-issue-management:tailwind-styles',
  tailwindStyles
);
export const tcIssueManagementTopicsStylesheet = createReusableStylesheet(
  'tc-issue-management:topics-styles',
  topicsStyles
);
export const tcIssueManagementIssueRightPanelStylesheet =
  createReusableStylesheet(
    'tc-issue-management:issue-right-panel-styles',
    issueRightPanelStyles
  );
export const tcIssueManagementIssueExportStylesheet = createReusableStylesheet(
  'tc-issue-management:issue-export-styles',
  issueExportStyles
);
export const tcIssueManagementIssueSharingModalStylesheet =
  createReusableStylesheet(
    'tc-issue-management:issue-sharing-modal-styles',
    issueSharingModalStyles
  );
export const tcIssueManagementIssueExchangeWidgetStylesheet =
  createReusableStylesheet(
    'tc-issue-management:issue-exchange-widget-styles',
    issueExchangeWidgetStyles
  );

export const tcIssueManagementStylesheets: readonly ReusableStylesheet[] = [
  tcwebReusableStylesheet,
  iconFontReusableStylesheet,
  tcIssueManagementTailwindStylesheet,
  tcIssueManagementBaseStylesheet,
  tcIssueManagementTopicsStylesheet,
  tcIssueManagementIssueRightPanelStylesheet,
  tcIssueManagementIssueExportStylesheet,
  tcIssueManagementIssueSharingModalStylesheet,
  tcIssueManagementIssueExchangeWidgetStylesheet,
];
